export const next = <T extends any>(
  obj: Record<string, T>,
  key: string,
  reverse?: boolean
) => {
  let found: boolean = false;
  const keys = Object.keys(obj);
  if (reverse) {
    keys.reverse();
  }
  for (const k of keys) {
    if (found) {
      return obj[k];
    }
    if (k === key) {
      found = true;
    }
  }
  return undefined;
};
